module.exports = __webpack_public_path__ + "img/heard01.41e56674.png";